import { getApiClient } from './client';

export interface KVEntry {
  key: string;
  value: Record<string, unknown>;
}

// Get all KV pairs for current user
export async function getAllKV(tenant: string): Promise<{ data: Record<string, Record<string, unknown>> }> {
  const client = getApiClient(tenant);
  try {
    return await client.get<{ data: Record<string, Record<string, unknown>> }>('/kv');
  } catch (error: any) {
    // Return empty data if error
    if (error?.status === 404) {
      return { data: {} };
    }
    throw error;
  }
}

// Get specific KV entry
export async function getKV(
  tenant: string,
  key: string
): Promise<{ key: string; value: Record<string, unknown> } | null> {
  const client = getApiClient(tenant);
  try {
    return await client.get<{ key: string; value: Record<string, unknown> }>(`/kv/${key}`);
  } catch (error: any) {
    // Return null if key not found (404)
    if (error?.status === 404) {
      return { key, value: {} };
    }
    throw error;
  }
}

// Set/update KV entry
export async function setKV(
  tenant: string,
  key: string,
  value: Record<string, unknown>
): Promise<{ success: boolean; key: string }> {
  const client = getApiClient(tenant);
  return client.put<{ success: boolean; key: string }>(`/kv/${key}`, { value });
}

// Delete KV entry
export async function deleteKV(tenant: string, key: string): Promise<{ success: boolean }> {
  const client = getApiClient(tenant);
  return client.delete<{ success: boolean }>(`/kv/${key}`);
}
